import { ExamCategory } from "../types/types";
import { getErrorMessage, privateApiClient } from "../utils/axios.utils";

class ExamCategoryService {
  /**
   * Fetch exam categories for an exam type.
   */
  async getExamCategories(examTypeId: number): Promise<ExamCategory[]> {
    try {
      const response = await privateApiClient.get<{
        data: { data: ExamCategory[] };
        message: string;
        success: boolean;
      }>(`/exam-categories/type/${examTypeId}`, {
        params: { exam_type_id: examTypeId },
      });

      return response.data.data.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }
}

export default new ExamCategoryService();
